import { useSyncExternalStore } from "react";

let state = { phase: "idle", step: 0 };
const listeners = new Set();

export const getTourState = () => state;

const ACTIVE_KEY = "memberTour:active";

const persist = () => {
  try {
    if (state.phase === "idle") sessionStorage.removeItem(ACTIVE_KEY);
    else sessionStorage.setItem(ACTIVE_KEY, JSON.stringify(state));
  } catch {}
};

export const setTourState = (next) => {
  state = { ...state, ...next };
  persist();
  listeners.forEach((listener) => listener());
};

export const readActiveTour = (owner) => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(ACTIVE_KEY) || "null");
    return saved && saved.phase !== "idle" && saved.owner === owner ? saved : null;
  } catch {
    return null;
  }
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useTourState = () => useSyncExternalStore(subscribe, getTourState);

// Logged-out sessions share the "guest" key; the tour only runs for signed-in agents.
const resumeKey = (userId) => `memberTour:resume:${userId || "guest"}`;

export const readTourResume = (userId) => {
  try {
    const saved = JSON.parse(localStorage.getItem(resumeKey(userId)) || "null");
    return Number.isInteger(saved?.step) ? saved : null;
  } catch {
    return null;
  }
};

export const saveTourResume = (userId, resume) => {
  try {
    if (resume) localStorage.setItem(resumeKey(userId), JSON.stringify(resume));
    else localStorage.removeItem(resumeKey(userId));
  } catch {}
};

const snoozeKey = (userId) => `memberTour:snoozed:${userId || "guest"}`;

export const isTourSnoozed = (userId) => {
  try {
    return sessionStorage.getItem(snoozeKey(userId)) === "1";
  } catch {
    return false;
  }
};

export const snoozeTour = (userId) => {
  try {
    sessionStorage.setItem(snoozeKey(userId), "1");
  } catch {}
};

const focusKey = (userId) => `memberTour:focus:${userId || "guest"}`;

export const readTourFocus = (userId) => {
  try {
    return localStorage.getItem(focusKey(userId));
  } catch {
    return null;
  }
};

export const saveTourFocus = (userId, focus) => {
  try {
    if (focus) localStorage.setItem(focusKey(userId), focus);
    else localStorage.removeItem(focusKey(userId));
  } catch {}
};
